(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mgr-aval-gallery"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-mgr-gallery]').forEach(gallery=>{
const thumbs=[...gallery.querySelectorAll('[data-gallery-thumb]')];
const main=gallery.querySelector('.mgr-gallery__main');
const large=gallery.querySelector('.mgr-gallery__large');
const dialog=gallery.querySelector('dialog');
let index=0;
const select=n=>{
index=(n+thumbs.length)%thumbs.length;
const thumb=thumbs[index];
main.removeAttribute('srcset');
main.src=thumb.dataset.full;
main.alt=thumb.dataset.alt;
large.src=thumb.dataset.full;
large.alt=thumb.dataset.alt;
thumbs.forEach((item,i)=>item.setAttribute('aria-pressed',String(i===index)));
};
thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>select(i)));
gallery.querySelectorAll('[data-gallery-step]').forEach(button=>button.addEventListener('click',()=>select(index+Number(button.dataset.galleryStep))));
gallery.querySelector('[data-gallery-open]').addEventListener('click',()=>{select(index);dialog.showModal()});
gallery.querySelector('[data-gallery-close]').addEventListener('click',()=>dialog.close());
dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});
gallery.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();select(index+(event.key==='ArrowLeft'?-1:1))}});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mgr-product-description"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
const button=event.target.closest('[data-mgr-video-play]');
if(!button)return;
const video=button.closest('.mgr-product-sheet__video-wrap').querySelector('video');
video.play().catch(()=>{button.hidden=false});
});
for(const type of ['play','pause','ended'])document.addEventListener(type,event=>{
const video=event.target;
if(!(video instanceof HTMLVideoElement))return;
const button=video.closest('.mgr-product-sheet__video-wrap')?.querySelector('[data-mgr-video-play]');
if(button)button.hidden=type==='play';
},true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mgr-product-differentials"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
const button=event.target.closest('.mgr-va-video [data-mgr-video-play]');
if(!button)return;
const video=button.closest('.mgr-product-sheet__video-wrap').querySelector('video');
video.play().catch(()=>{button.hidden=false});
});
for(const type of ['play','pause','ended'])document.addEventListener(type,event=>{
const video=event.target;
if(!(video instanceof HTMLVideoElement)||!video.closest('.mgr-va-video'))return;
const button=video.closest('.mgr-product-sheet__video-wrap')?.querySelector('[data-mgr-video-play]');
if(button)button.hidden=type==='play';
},true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mgr-velador-gallery"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-mgr-gallery]').forEach(gallery=>{
const thumbs=[...gallery.querySelectorAll('[data-gallery-thumb]')];
const main=gallery.querySelector('.mgr-gallery__main');
const large=gallery.querySelector('.mgr-gallery__large');
const dialog=gallery.querySelector('dialog');
let index=0;
const select=n=>{
index=(n+thumbs.length)%thumbs.length;
const thumb=thumbs[index];
main.removeAttribute('srcset');
main.src=thumb.dataset.full;
main.alt=thumb.dataset.alt;
large.src=thumb.dataset.full;
large.alt=thumb.dataset.alt;
thumbs.forEach((item,i)=>item.setAttribute('aria-pressed',String(i===index)));
};
thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>select(i)));
gallery.querySelectorAll('[data-gallery-step]').forEach(button=>button.addEventListener('click',()=>select(index+Number(button.dataset.galleryStep))));
gallery.querySelector('[data-gallery-open]').addEventListener('click',()=>{select(index);dialog.showModal()});
gallery.querySelector('[data-gallery-close]').addEventListener('click',()=>dialog.close());
dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});
gallery.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();select(index+(event.key==='ArrowLeft'?-1:1))}});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mgr-vitrina-rack-sheet"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
const button=event.target.closest('[data-mgr-set-video-play]');
if(!button)return;
const wrap=button.closest('[data-mgr-set-video]');
const iframe=wrap.querySelector('iframe');
iframe.src=iframe.dataset.src;
iframe.hidden=false;
const poster=wrap.querySelector('.mgr-set-video__poster');
if(poster)poster.hidden=true;
button.hidden=true;
iframe.focus();
});
  } catch(e) { console.error(e); }
})();

})();
